import { useContext, useEffect, useState } from "react";
import { OidcIdentityContext } from "@rsmus/react-auth";
import { taxPortalClientApi } from "../../api-client-nswag/taxportal-client-runtime";

function getSiteId(): number | undefined {
    // When embedded in an iframe, the site info is on the parent (referrer) URL, not this page's own URL.
    const url = window.location !== window.parent.location ? document.referrer : document.location.href;
    const urlParams = url ? new URL(url) : null;
    const params = urlParams ? new URLSearchParams(urlParams.search) : null;
    let rawSiteId = params?.get("metaData.siteID") ?? params?.get("siteID") ?? params?.get("siteId");

    if (rawSiteId) {
        sessionStorage.setItem("siteId", rawSiteId);
    } else {
        rawSiteId = sessionStorage.getItem("siteId");
    }

    const siteId = Number(rawSiteId);
    return rawSiteId && Number.isInteger(siteId) ? siteId : undefined;
}

const SiteNotification = () => {
    const { user } = useContext(OidcIdentityContext);
    const [data, setData] = useState<any>(null);
    const [siteId] = useState<number | undefined>(getSiteId);

    useEffect(() => {
        const username = user?.profile?.preferred_username;
        if (!username) return;

        taxPortalClientApi.siteNotification_GetSiteNotificationsForUser(siteId, username)
            .then((result) => {
                console.log("Site notification messages:", result);
                setData(result);
            })
            .catch((error) => console.error(error));
            
    }, [siteId, user?.profile?.preferred_username]);

    const messages: string[] = Array.isArray(data)
        ? data.map((item) => item?.notificationMessage).filter(Boolean)
        : data?.notificationMessage
            ? [data.notificationMessage]
            : [];
    return (
        <div style={{ width: "100%", minHeight: "100vh",  padding: "20px", boxSizing: "border-box" }}>
            {messages.length > 0
                ? messages.map((message, index) => (
                    <p key={index} style={{ fontStyle: "italic", fontWeight: "bold", fontSize: "20px", whiteSpace: "pre-wrap" }}>{message}</p>
                ))
                : null}
        </div>
    );
};

export default SiteNotification;
